import TimelineNode from 'components/dossiers/dossierFollowUp/TimelineNode';
import React from 'react'
import { connect } from "react-redux";
import { Button, Divider, Grid, Header, Item, Menu, Segment } from "semantic-ui-react";
import { findEntity } from "../../../selectors/entities";
import EditModal from "../../forms/EditModal";
import { DynamicRichTextRender } from "../../forms/richText/RichTextRender";
import PrintableComponent, { getPrintButton } from "../../printing/PrintableComponent";
import ActionsMenu  from "./ActionsMenu";
import DossierItemForm from "./DossierItemForm";

class NoteNode extends React.Component {
  render() {
    const {isSelected, time, nodeStyle, dossierItem, patient} = this.props
    const patientName = patient? `${patient?.firstName} ${patient?.lastName}:` : ''
    const editModalHeader = `${patientName} ${I18n.t('components.dossier_item.note')}`

    return (
      <TimelineNode icon={'sticky note'} type={'note'} {...this.props}>
        <PrintableComponent ref={element => (this.printRef = element)}>
          <Item as={Segment} raised={isSelected} clearing contentEditable={false} style={nodeStyle}>
            <Item.Content>
              <Grid divided>
                <Grid.Row>
                  <Grid.Column width={9}>
                    <Header>{dossierItem.title}</Header>
                    <Item.Description>{I18n.l("date.formats.short_human_readable", time)}</Item.Description>
                  </Grid.Column>
                  <Grid.Column width={5} floated='right' textAlign='right' className='dont-print'>
                    <Menu compact borderless secondary stackable>
                      <Menu.Item>
                        <EditModal entityName="dossierItem" EntityForm={DossierItemForm} header={editModalHeader}
                                   entityId={dossierItem.id} trigger={(props) => {
                          return (
                            <Button onClick={props.onClick} icon='pencil'/>)
                        }}
                        />
                      </Menu.Item>
                      <ActionsMenu printRef={this.printRef} noteId={dossierItem.id}/>
                    </Menu>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Item.Content>
            <Item.Content>
              <Divider/>
              <DynamicRichTextRender content={dossierItem.text}/>
            </Item.Content>
          </Item>
        </PrintableComponent>
      </TimelineNode>)
  }
}

const mapStateToProps = (state, ownProps) => {
  let dossier = findEntity(state, 'dossier', ownProps.dossierId)
  let patient = findEntity(state, 'contact', dossier && dossier.patientId)

  return {
    patient: patient,
  }
}

export default connect(mapStateToProps, null)(NoteNode)

